'use client'

import { useMemo } from 'react'

import { urlReplaceOrigin } from '../url-handling'

import { useCdnContext } from './components/CdnProvider'

export const useCdnMediaServer = (): {
  setMediaServerOrigin: (uri: string) => string
} => {
  const { mediaServerUrl } = useCdnContext()

  return useMemo(() => {
    const setMediaServerOrigin = (uri: string): string =>
      urlReplaceOrigin(uri, mediaServerUrl)

    return {
      setMediaServerOrigin,
    }
  }, [mediaServerUrl])
}
